import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const loggingService = this.injector.get(LoggingService);
    const message = error.message ? error.message : error.toString();
    const stack = error.stack ? error.stack : '';

    loggingService.error(message, { stack });

    // Rethrow the error so that it is also logged to the console
    throw error;
  }
}
